import React from 'react';

const heading = {
    color: 'black',
    fontSize: '24px',
    marginBottom: '10px',
};

const Address = (props) => (
    <div className="col-sm-12 col-md-6">
        <h5 style={heading}>{props.data.country}</h5>
        <p>{props.data.floor}</p>
        <p>{props.data.address}</p>
        <p>{props.data.street}</p>
        <p>{props.data.postal}</p>
        <p>{props.data.tel}</p>
        <p>{props.data.fax}</p>
        <p>{props.data.mobile}</p>
        {
            (props.data.map) ? (
                <a href={props.data.map} target="_blank" rel="noopener noreferrer"><p>locate us here.</p></a>
            ) : (
                null
            )
        }
        <div className="invisible p-3"></div>
    </div>
);

export default Address;



// WEBPACK FOOTER //
// ./src/components/address.js